export const isElectronicVotingEnabled = (m) => {
    const raw = m?.bAllowElectronicVoting;
    if (raw === true) return true;
    if (typeof raw === 'string' && raw.trim().toUpperCase() === 'Y') return true;
    return false;
};

export const filterMeetingsForTemplate = (list, isOnlineVotingTemplate) =>
    isOnlineVotingTemplate
        ? (list || []).filter(isElectronicVotingEnabled)
        : (list || []);

export const getLotsInRange = (planNumberLots, rangeStart, rangeEnd) => {
    const sortedLots = [...(planNumberLots || [])].sort((a, b) =>
        String(a.lot_number ?? '').localeCompare(
            String(b.lot_number ?? ''),
            undefined,
            { numeric: true, sensitivity: 'base' }
        )
    );
    const startIndex = sortedLots.findIndex(lot => lot.lot_number === rangeStart);
    const endIndex = sortedLots.findIndex(lot => lot.lot_number === rangeEnd);

    if (startIndex === -1 || endIndex === -1) return { lots: [], error: 'invalid' };
    if (startIndex > endIndex) return { lots: [], error: 'order' };
    return { lots: sortedLots.slice(startIndex, endIndex + 1), error: null };
};

export const validateCustomRecipients = (customRecipients, sendTo, lotsUserTypes, setErrors) => {
    if (!customRecipients || !Array.isArray(customRecipients) || customRecipients.length === 0) {
        setErrors(prev => ({
            ...prev,
            customRecipientsValidation: false,
            customRecipientsValidationMessage: ''
        }));
        return true;
    }

    const sendToArray = sendTo ? sendTo.split('_') : [];

    const getAllowedTypes = () => {
        const allowedTypes = new Set();

        if (sendToArray.includes('lotOnly')) {
            if (lotsUserTypes && lotsUserTypes.includes('owner')) {
                allowedTypes.add('owner');
                allowedTypes.add('owner-agent');
            }
            if (lotsUserTypes && lotsUserTypes.includes('agent')) {
                allowedTypes.add('agent');
            }
            if (lotsUserTypes && lotsUserTypes.includes('residents-tenants')) {
                allowedTypes.add('tenant');
                allowedTypes.add('owner'); // owner-occupied owners
            }
        } else {
            if (sendToArray.includes('owners')) {
                allowedTypes.add('owner');
                allowedTypes.add('owner-agent');
            }
            if (sendToArray.includes('residents')) {
                allowedTypes.add('owner'); // owner-occupied
                allowedTypes.add('tenant');
            }
            if (sendToArray.includes('agents')) {
                allowedTypes.add('agent');
            }
            if (sendToArray.includes('tenants')) {
                allowedTypes.add('tenant');
            }
        }

        return allowedTypes;
    };

    const allowedTypes = getAllowedTypes();

    if (allowedTypes.size === 0) {
        setErrors(prev => ({
            ...prev,
            customRecipientsValidation: false,
            customRecipientsValidationMessage: ''
        }));
        return true;
    }

    const invalidRecipients = customRecipients.filter(recipient => {
        const type = recipient.type?.toLowerCase();
        return !allowedTypes.has(type);
    });

    if (invalidRecipients.length > 0) {
        setErrors(prev => ({
            ...prev,
            customRecipientsValidation: true,
            customRecipientsValidationMessage: 'The imported recipient type should match the "Send to" selection'
        }));
        return false;
    }

    setErrors(prev => ({
        ...prev,
        customRecipientsValidation: false,
        customRecipientsValidationMessage: ''
    }));
    return true;
};
